import { render, staticRenderFns } from "./MultiAnnSelection.vue?vue&type=template&id=4869a22e&"
import script from "./MultiAnnSelection.vue?vue&type=script&lang=js&"
export * from "./MultiAnnSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports